/* HIP&TELL Fit Finder. Dipindah dari sections/fit-finder.liquid (2026-09-13) — logika identik, hanya dibungkus boot() + guard sekali-muat. */
(function () {
  if (window.htFitFinderBoot) { window.htFitFinderBoot(); return; }
  var SIZES        = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var WEIGHT_BANDS = [49, 57, 66, 75, 85, 95, 107, 120];  // kg — upper bound per size (TODO: read per-product grading metafield if graded)
  var WAIST_BANDS  = [63, 70, 78, 86, 95, 105, 116, 128];  // cm — upper bound per size (TODO: read per-product grading metafield if graded)

  // Indonesian locales type comma decimals ("58,5") — normalise the comma to a
  // dot BEFORE stripping non-digits, else 58,5 becomes 585 kg (pdp-extras audit B2).
  function num(v) { return parseFloat(String(v || '').replace(',', '.').replace(/[^0-9.]/g, '')); }
  function idxFrom(bands, v) { v = (typeof v === 'number') ? v : num(v); if (!v || v <= 0) return -1; var i = 0; while (i < bands.length && v > bands[i]) i++; return i; }
  // ── Copy per market (2026-09-14, Blywee: Indonesian for Indonesian shoppers,
  // plain short words; MY/SG stay English) ──────────────────────────────────
  // sections/fit-finder.liquid stamps data-ff-lang="id" on the section for the
  // Indonesia market (blank country = primary market = ID, the same gate as
  // ht-model-wears); every section on a page shares one market, so one LANG is
  // enough. The one-tap "Add size X to cart" button and its states are NOT in
  // this table on purpose: they mirror the ADD TO CART sticky bar (brand layer;
  // "Bag" → "Cart" store-wide, Blywee 2026-09-14).
  var STR = {
    en: {
      lenPetite: 'Petite length is your best match.', lenTall: 'Tall length is your best match.', lenRegular: 'Regular length fits you.',
      prefLoose: 'Sized up one for a relaxed, roomy fit.', prefFit: 'True to size — cut close for our everyday fit.',
      refined: ' Refined with your measurements.',
      moreOpen: '– Hide waist & hips', moreClosed: '+ Add waist & hips for a more precise fit',
      recFor: function (h, w) { return 'Recommended for ' + h + (IMPERIAL ? ' / ' + w + ' lb: ' : ' cm / ' + w + ' kg: '); },
      recSize: function (s) { return 'size ' + s; },
      notMade: function (s) { return 'This style isn’t made in size ' + s + '.'; },
      closestCarry: function (s) { return ' Closest we do carry: size ' + s + '.'; },
      soldOutClosest: function (a, b) { return 'Size ' + a + ' is sold out right now. Closest in stock: size ' + b + '.'; },
      allSoldOut: 'Every size is sold out right now — save it to your wishlist and we’ll restock.',
      soldOut: function (s) { return 'Size ' + s + ' is sold out right now.'; },
      chipSoldOut: '— sold out right now',
      chipClosest: function (s) { return '(size ' + s + ' sold out — closest in stock)'; },
      chipNotMade: '(not made in this style — closest size)'
    },
    id: {
      lenPetite: 'Panjang Petite paling pas.', lenTall: 'Panjang Tall paling pas.', lenRegular: 'Panjang Regular paling pas.',
      prefLoose: 'Naik satu ukuran, potongan lebih longgar.', prefFit: 'Sesuai ukuran badan, potongan pas.',
      refined: ' Disesuaikan dengan pinggang & pinggul.',
      moreOpen: '– Tutup pinggang & pinggul', moreClosed: '+ Tambah pinggang & pinggul biar lebih pas',
      recFor: function (h, w) { return 'Rekomendasi untuk ' + h + ' cm / ' + w + ' kg: '; },
      recSize: function (s) { return 'ukuran ' + s; },
      notMade: function (s) { return 'Model ini tidak dibuat di ukuran ' + s + '.'; },
      closestCarry: function (s) { return ' Yang paling dekat: ukuran ' + s + '.'; },
      soldOutClosest: function (a, b) { return 'Ukuran ' + a + ' sedang habis. Yang tersedia paling dekat: ukuran ' + b + '.'; },
      allSoldOut: 'Semua ukuran sedang habis — simpan ke wishlist, kami akan restock.',
      soldOut: function (s) { return 'Ukuran ' + s + ' sedang habis.'; },
      chipSoldOut: '— sedang habis',
      chipClosest: function (s) { return '(ukuran ' + s + ' habis — yang tersedia paling dekat)'; },
      chipNotMade: '(tidak dibuat di model ini — ukuran terdekat)'
    }
  };
  var LANG = 'en';
  // ── United States market (2026-09-26): shoppers type height as ft/in, weight in
  // lb, waist & hips in inches. sections/fit-finder.liquid stamps
  // data-ff-units="imperial"; everything below the input layer stays metric (the
  // bands, the per-product chart, lenNote), so only these converters change.
  var IMPERIAL = false;
  function parseHeightIn(v) {
    var s = String(v || '').trim().toLowerCase().replace(/[”″]/g, '"').replace(/[’′]/g, "'");
    if (!s) return NaN;
    var m = s.match(/^(\d+)\s*(?:'|ft|feet|f)\s*(\d+(?:\.\d+)?)?\s*(?:"|in|inches)?$/);   // 5'5  5 ft 5  5'5"
    if (m) return parseInt(m[1], 10) * 12 + (m[2] ? parseFloat(m[2]) : 0);
    m = s.match(/^(\d+)\s*[.,]\s*(\d{1,2})$/);                                             // 5.5 / 5,11 = 5 ft 5 in / 5 ft 11 in
    if (m && parseInt(m[1], 10) <= 8) return parseInt(m[1], 10) * 12 + parseInt(m[2], 10);
    m = s.match(/^(\d+)\s+(\d+)$/);                                                         // 5 5
    if (m && parseInt(m[1], 10) <= 8) return parseInt(m[1], 10) * 12 + parseInt(m[2], 10);
    var n = num(s);
    if (!n) return NaN;
    return n < 10 ? n * 12 : n;                                                                // 5 = 5 ft · 65 = inches
  }
  function toCm(v) { if (!IMPERIAL) return num(v); var i = parseHeightIn(v); return i ? i * 2.54 : NaN; }
  function toKg(v) { var n = num(v); return IMPERIAL ? n / 2.20462 : n; }
  function toCmLen(v) { var n = num(v); return IMPERIAL ? n * 2.54 : n; }
  function fmtH(v) {
    v = String(v || '').trim(); if (!IMPERIAL) return v;
    var i = parseHeightIn(v); if (!i) return v;
    var ft = Math.floor(i / 12), inch = Math.round(i - ft * 12); if (inch === 12) { ft += 1; inch = 0; }
    return ft + "'" + inch + '"';
  }
  function T(k) { var v = STR[LANG] && STR[LANG][k]; return v === undefined ? STR.en[k] : v; }
  function lenNote(h) { h = num(h); if (!h) return ''; if (h < 157) return T('lenPetite'); if (h > 175) return T('lenTall'); return T('lenRegular'); }
  function prefNote(p) { return p === 'loose' ? T('prefLoose') : T('prefFit'); }

  // Store variant labels render as XXL/XXXL… while the finder speaks 2XL/3XL… —
  // canonicalise BOTH sides (XX…L -> nXL) before comparing.
  function canonSize(x) { x = String(x || '').toUpperCase().replace(/\s/g, ''); var m = x.match(/^(X{2,6})L$/); if (m) return m[1].length + 'XL'; return x; }

  // ── Stock awareness (audit finding ③, 2026-07-28) ─────────────────────────
  // The finder used to treat `input.disabled` as "sold out". It is not. Prestige
  // only disables the radio when hide_sold_out_variants is ON; this store runs it
  // OFF (templates/product.json), so a sold-out size renders as a perfectly
  // enabled radio whose LABEL carries the class "is-disabled" — see the
  // block-swatch branch of snippets/option-value.liquid. So the old check never
  // once fired: applySize happily selected a sold-out size and the button
  // reported "✓ Size L selected". Read the label's class instead.
  //
  // All of this is PDP-only. On the homepage there is no variant picker, so
  // chips() returns [] and every caller below degrades to the old behaviour.
  function chips() {
    var inputs = document.querySelectorAll('input[type="radio"][form^="product-form-main-"]');
    if (!inputs.length) inputs = document.querySelectorAll('variant-picker input[type="radio"], .variant-picker__option-values input[type="radio"]');
    return Array.prototype.map.call(inputs, function (input) {
      var label = (input.labels && input.labels[0]) || null;
      var swatch = label ? (label.querySelector('.block-swatch, .thumbnail-swatch, .color-swatch') || label) : null;
      var host = swatch || label;
      return {
        input: input,
        size: canonSize(label ? label.textContent : input.value),
        available: !input.disabled && !(host && host.classList.contains('is-disabled'))
      };
    });
  }

  function chipFor(size) {
    var want = canonSize(size);
    var all = chips();
    for (var i = 0; i < all.length; i++) { if (all[i].size === want) return all[i]; }
    return null;
  }

  // Nearest size that can actually be bought, preferring to size UP (a garment
  // one size large is wearable; one size small is a return).
  function nearestAvailable(size, ladder) {
    var all = chips();
    if (!all.length) return null;
    var order = (ladder && ladder.length ? ladder : SIZES).map(canonSize);
    var from = order.indexOf(canonSize(size));
    if (from < 0) return null;
    var best = null, bestScore = Infinity;
    all.forEach(function (c) {
      if (!c.available) return;
      var at = order.indexOf(c.size);
      if (at < 0) return;
      var dist = Math.abs(at - from);
      var score = dist * 2 + (at < from ? 1 : 0);  // tie-break: bigger wins
      if (score < bestScore) { bestScore = score; best = c.size; }
    });
    return best;
  }

  function anyAvailable() {
    return chips().some(function (c) { return c.available; });
  }

  // Selects the chip. Returns true when the size exists on this product — being
  // sold out is NOT a reason to refuse: selecting it is what makes the buy box
  // and the sticky bar say "Sold out" rather than leaving a stale size showing.
  function applySize(size) {
    if (!size) return false;
    var chip = chipFor(size);
    if (!chip) return false;                      // size isn't offered on this product at all
    if (!chip.input.checked) { chip.input.click(); }  // click() fires the change Prestige listens for
    return true;
  }

  // Per-product grading: the PDP injects the custom.size_chart metafield as an
  // application/json block [data-ff-chart] next to the form. When present, the
  // finder speaks the product's OWN size ladder + waist/hips upper bounds; when
  // absent (homepage, unmeasured product) it keeps the generic bands above.
  function ladderFrom(form) {
    var L = { sizes: SIZES, waist: WAIST_BANDS, hips: null, weight: WEIGHT_BANDS };
    var el = form.parentElement.querySelector('[data-ff-chart]');
    if (!el) return L;
    try {
      var chart = JSON.parse(el.textContent);
      var tables = (chart.tables || []).filter(function (t) { return t.columns && t.rows && t.rows.length; });
      // sets carry 2 tables — prefer the one with a Waist column (bottoms), else the first
      var t = tables.filter(function (x) {
        return x.columns.some(function (c) { return /^waist/i.test(String(c)); });
      })[0] || tables[0];
      if (!t) return L;
      var cols = t.columns.map(function (c) { return String(c).toLowerCase(); });
      var wCol = -1, hCol = -1;
      cols.forEach(function (c, i) { if (i > 0 && wCol < 0 && c.indexOf('waist') === 0) wCol = i; if (i > 0 && hCol < 0 && c.indexOf('hip') === 0) hCol = i; });
      var upper = function (cell) { var m = String(cell || '').match(/(\d+(?:[.,]\d+)?)\s*$/); return m ? parseFloat(m[1].replace(',', '.')) : NaN; };
      var sizes = [], waist = [], hips = [];
      t.rows.forEach(function (r) {
        sizes.push(String(r[0] || '').trim());  // raw label for display; applySize canonicalises when matching
        waist.push(wCol > 0 ? upper(r[wCol]) : NaN);
        hips.push(hCol > 0 ? upper(r[hCol]) : NaN);
      });
      if (!sizes.length) return L;
      L.sizes = sizes;
      // bands = upper bound per size EXCEPT the last (top size is open-ended)
      L.waist = (wCol > 0 && waist.every(isFinite)) ? waist.slice(0, -1) : null;
      L.hips = (hCol > 0 && hips.every(isFinite)) ? hips.slice(0, -1) : null;
      L.weight = WEIGHT_BANDS.slice(0, Math.max(sizes.length - 1, 0));
      return L;
    } catch (e) { return L; }
  }

  // ── Remembered profile (Blywee 2026-09-11, ala Shopee "Profil Ukuran" tanpa login) ──
  // Height / weight / fit preference live in localStorage on the shopper's phone.
  // Next product page: fields are prefilled and the recommendation is applied to
  // the size chips silently — no need to tap "Get my fit" again.
  var PROFILE_KEY = 'ht-fit-profile-v1';
  function readProfile() { try { var p = JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null'); return (p && p.h && p.w) ? p : null; } catch (e) { return null; } }
  function writeProfile(p) { try { localStorage.setItem(PROFILE_KEY, JSON.stringify(p)); } catch (e) {} }

  // Mark the recommended size on the PDP picker itself: a hairline on the chip and
  // one small line under the row. Shoppers were finding the answer inside the finder
  // and then losing it on the way back up to the size row (Clarity 2026-09-10).
  // State shared across repeated executions of this script (section rendered
  // twice / editor reloads): one replay function, one document listener.
  var SHARED = window.__htFit = window.__htFit || { replay: null };
  function markChip(mark) {
    var all = chips();
    if (!all.length) return;
    var values = null;
    all.forEach(function (c) {
      var label = (c.input.labels && c.input.labels[0]) || null;
      var host = label ? (label.querySelector('.block-swatch, .thumbnail-swatch, .color-swatch') || label) : null;
      if (!host) return;
      var hit = !!(mark && mark.size && c.size === canonSize(mark.size));
      host.classList.toggle('is-ff-rec', hit);
      if (mark && c.size === canonSize(mark.wanted)) values = c.input.closest('.variant-picker__option-values');
    });
    var line = document.querySelector('.ht-ff-recline');
    if (!mark || !values) { if (line) line.remove(); return; }
    if (!line) { line = document.createElement('p'); line.className = 'ht-ff-recline'; }
    // Text nodes only — height/weight are free-text inputs, never markup.
    line.textContent = '';
    line.appendChild(document.createTextNode(T('recFor')(mark.h, mark.w)));
    var b = document.createElement('b'); b.textContent = T('recSize')(mark.wanted); line.appendChild(b);
    if (mark.note) { var n = document.createElement('span'); n.textContent = ' ' + mark.note; line.appendChild(n); }
    if (line.parentNode !== values.parentNode) values.parentNode.insertBefore(line, values.nextSibling);
  }
  // Prestige refreshes the picker on variant change (colour swap = new stock) —
  // recompute the recommendation instead of replaying a stale mark.
  if (!document.documentElement.dataset.htFfVc) {
    document.documentElement.dataset.htFfVc = '1';
    document.addEventListener('variant:change', function () { if (SHARED.replay) SHARED.replay(); });
  }

  function init(form) {
    if (form.dataset.ffReady) return; form.dataset.ffReady = '1';
    var L = ladderFrom(form);

    var segs = form.querySelectorAll('.ht-fitfinder__seg');
    var active = form.querySelector('.ht-fitfinder__seg[aria-pressed="true"]');
    var pref = active ? active.getAttribute('data-fit') : 'fit';
    segs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pref = btn.getAttribute('data-fit');
        segs.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });

    var moreBtn = form.querySelector('.ht-fitfinder__more');
    var optional = form.querySelector('.ht-fitfinder__optional');
    if (moreBtn && optional) {
      moreBtn.addEventListener('click', function () {
        var open = optional.classList.toggle('is-open');
        moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        moreBtn.textContent = open ? T('moreOpen') : T('moreClosed');
      });
    }

    var errorEl = form.querySelector('.ht-fitfinder__error');
    var resultEl = form.querySelector('.ht-fitfinder__result');
    var applyBtn = form.querySelector('.ht-fitfinder__apply');
    if (applyBtn) applyBtn.dataset.label = applyBtn.textContent;
    var lastSize = '';
    // What the apply button will actually select: the recommendation when it is
    // in stock, the nearest size that IS in stock when it isn't, null when there
    // is nothing to select at all.
    var applyTarget = '';

    // Empty-field errors live UNDER the empty field, in red, and re-shake on every
    // tap. The old single grey line under the button was missed on phones: Clarity
    // 2026-09-11 shows one shopper tapping "Get my fit" 8x in 50s with one field
    // blank, then leaving — every tap after the first changed nothing on screen.
    function flagEmpty() {
      var first = null;
      ['height', 'weight'].forEach(function (n) {
        var input = form.querySelector('[name="' + n + '"]');
        var field = input && input.closest('.ht-fitfinder__field');
        if (!field) return;
        field.classList.remove('is-bad', 'is-shake'); input.removeAttribute('aria-invalid');
        if (!input.value.trim()) {
          field.classList.add('is-bad'); input.setAttribute('aria-invalid', 'true');
          void field.offsetWidth; // restart the shake on repeat taps
          field.classList.add('is-shake');
          if (!first) first = input;
        }
      });
      return first;
    }
    form.querySelectorAll('.ht-fitfinder__input').forEach(function (input) {
      input.addEventListener('input', function () {
        var field = input.closest('.ht-fitfinder__field');
        if (field && input.value.trim()) { field.classList.remove('is-bad', 'is-shake'); input.removeAttribute('aria-invalid'); }
      });
    });

    form.addEventListener('submit', function (e) { e.preventDefault(); run(false); });

    // silent = replaying a remembered profile on page load: no scroll, no focus.
    function run(silent) {
      var g = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
      var firstEmpty = flagEmpty();
      if (firstEmpty) {
        resultEl.hidden = true; if (errorEl) errorEl.hidden = true;
        if (!silent) firstEmpty.focus({ preventScroll: true });
        return;
      }
      var idx = idxFrom(L.weight, toKg(g('weight')));
      var wi = L.waist ? idxFrom(L.waist, toCmLen(g('waist'))) : -1;
      var hi = L.hips ? idxFrom(L.hips, toCmLen(g('hips'))) : -1;
      // Bottoms must FIT the larger measurement — take the bigger of waist/hips,
      // then blend with the weight estimate the way waist alone used to.
      var mi = Math.max(wi, hi);
      if (mi >= 0) idx = idx < 0 ? mi : Math.round((idx + mi) / 2);

      if (idx < 0) { resultEl.hidden = true; if (errorEl) errorEl.hidden = false; return; }
      if (errorEl) errorEl.hidden = true;

      if (pref === 'loose') idx = idx + 1;
      idx = Math.min(idx, L.sizes.length - 1);
      lastSize = L.sizes[idx];

      form.querySelector('[data-size]').textContent = lastSize;
      form.querySelector('[data-note]').textContent = prefNote(pref) + (mi >= 0 ? T('refined') : '');
      var len = lenNote(toCm(g('height'))), lenEl = form.querySelector('[data-len]');
      if (len) { lenEl.textContent = len; lenEl.hidden = false; } else { lenEl.hidden = true; }

      // ── Say it out loud when the size we just recommended can't be bought ──
      // Four of six plausible body shapes on Kelly land on a size that is out of
      // stock, because the holes are in the middle sizes that sell hardest. The
      // finder used to hand those shoppers a confident "✓ Size L selected" and
      // leave them at a dead end.
      var chip = chipFor(lastSize);
      var onPdp = chips().length > 0;
      var soldOutEl = form.querySelector('[data-soldout]');
      var stockEl = form.querySelector('[data-stock]');
      applyTarget = lastSize;

      if (!onPdp) {
        // Homepage: no product in context, so no stock claim either way.
        if (soldOutEl) soldOutEl.hidden = true;
        if (stockEl) stockEl.hidden = true;
      } else if (!chip) {
        if (soldOutEl) soldOutEl.hidden = true;
        if (stockEl) {
          stockEl.textContent = T('notMade')(lastSize);
          stockEl.hidden = false;
        }
        applyTarget = nearestAvailable(lastSize, L.sizes);
        if (applyTarget && stockEl) {
          stockEl.textContent += T('closestCarry')(applyTarget);
        }
      } else if (!chip.available) {
        if (soldOutEl) soldOutEl.hidden = false;
        applyTarget = nearestAvailable(lastSize, L.sizes);
        if (stockEl) {
          if (applyTarget) {
            stockEl.textContent = T('soldOutClosest')(lastSize, applyTarget);
          } else if (!anyAvailable()) {
            stockEl.textContent = T('allSoldOut');
          } else {
            stockEl.textContent = T('soldOut')(lastSize);
          }
          stockEl.hidden = false;
        }
      } else {
        if (soldOutEl) soldOutEl.hidden = true;
        if (stockEl) stockEl.hidden = true;
      }

      if (applyBtn) {
        // Never offer to select nothing, and never call a sold-out size a match.
        if (!applyTarget) {
          applyBtn.hidden = true;
        } else {
          applyBtn.hidden = false;
          if (!applyBtn.hasAttribute('data-ht-adding')) applyBtn.textContent = applyLabel(applyTarget);
        }
      }

      resultEl.hidden = false;
      // The result box (~240px) renders below the button with no scroll; with the
      // button low on a phone screen it was cut off, so shoppers re-tapped while
      // changing numbers. Bring the whole box into view.
      if (!silent) { try { var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; resultEl.scrollIntoView({ block: 'nearest', behavior: calm ? 'auto' : 'smooth' }); } catch (err) {} }

      writeProfile({ h: g('height').trim(), w: g('weight').trim(), pref: pref, u: IMPERIAL ? 'in' : 'cm' });
      if (onPdp) {
        var note = '';
        if (!applyTarget) note = T('chipSoldOut');
        else if (applyTarget !== lastSize) note = chip ? T('chipClosest')(lastSize) : T('chipNotMade');
        markChip({ size: applyTarget, wanted: applyTarget || lastSize, h: fmtH(g('height')), w: g('weight').trim(), note: note });
        SHARED.replay = function () { run(true); };
      }

      // PDP hook — a size selector on the page can listen for this and pre-select `size`.
      // `available` and `applies` let a listener tell a real match from a fallback.
      form.dispatchEvent(new CustomEvent('fit:recommended', {
        bubbles: true,
        detail: { size: lastSize, available: onPdp ? !!(chip && chip.available) : null, applies: applyTarget }
      }));
    }

    // Remembered profile → prefill, then apply silently (PDP only: the homepage
    // finder has no size row to mark, and a pre-shown result there reads as stale).
    var saved = readProfile();
    if (saved && (saved.u || 'cm') !== (IMPERIAL ? 'in' : 'cm')) saved = null;   // typed in the other market's units
    if (saved) {
      var hIn = form.querySelector('[name="height"]'), wIn = form.querySelector('[name="weight"]');
      if (hIn && !hIn.value) hIn.value = saved.h;
      if (wIn && !wIn.value) wIn.value = saved.w;
      if (saved.pref === 'fit' || saved.pref === 'loose') {
        pref = saved.pref;
        segs.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fit') === pref ? 'true' : 'false'); });
      }
      if (chips().length) run(true);
    }

    // ONE-TAP ADD (Blywee 2026-09-13, test): the result button no longer only
    // selects the chip — it selects the size AND adds it to the bag, the same
    // path the sticky bar uses (click the form's real submit, Prestige adds and
    // opens the cart drawer). Why: Clarity 11–13 Sep — 92 sessions tapped "Get
    // my fit", 5 added to bag; after a recommendation the shopper still had to
    // find the chip and then find Add to Bag. When the size is not the one we
    // recommended (sold out → nearest in stock) the stock note above the button
    // already says so; the button just names the size it will add.
    function applyLabel(size) {
      return onPdpNow() ? 'Add size ' + size + ' to cart' : (applyBtn ? applyBtn.dataset.label : '');
    }
    function onPdpNow() { return chips().length > 0; }
    function mainSubmit() {
      var f = document.querySelector('form[id^="product-form-main-"]');
      return f ? f.querySelector('[type="submit"]') : null;
    }
    // Picking a chip is async in Prestige (section fetch); the variant lock
    // (snippets/ht-variant-lock.liquid) holds every buy control inert until the
    // re-render lands, and a programmatic click during that window is cancelled.
    // So: click the chip, then wait for the lock to clear before submitting.
    // Review 2026-09-13 (P2): only the VARIANT LOCK (data-ht-lock) is a reason
    // to wait. aria-busy without the lock = Prestige is already adding (a tap
    // on the inline/sticky Add to Bag landed first) — bail, or we queue a
    // second unit behind it. Success/failure is what the form REPORTS
    // (variant:add / cart:error), not the click: Shopify can refuse ("All 1
    // items are in your cart") after the click went through. Cap matches the
    // lock's own 8 s safety so a slow section fetch is not called "unavailable".
    function addWhenReady(done) {
      var tries = 0, form = document.querySelector('form[id^="product-form-main-"]');
      (function poll() {
        var btn = mainSubmit();
        if (!btn) { done('gone'); return; }
        if (btn.hasAttribute('data-ht-lock')) { if (++tries > 80) { done('slow'); return; } setTimeout(poll, 100); return; }
        if (btn.getAttribute('aria-busy') === 'true') { done('busy'); return; }
        if (btn.disabled) { done('soldout'); return; }
        var settled = false;
        function finish(state) { if (settled) return; settled = true; clearTimeout(t); if (form) { form.removeEventListener('variant:add', ok); form.removeEventListener('cart:error', bad); } done(state); }
        function ok() { finish('added'); }
        function bad() { finish('error'); }
        var t = setTimeout(function () { finish('slow'); }, 8000);
        if (form) { form.addEventListener('variant:add', ok); form.addEventListener('cart:error', bad); }
        btn.click();
      })();
    }
    // aria-disabled (not disabled) keeps focus on the button while it works,
    // and aria-live lets a screen reader hear the state change (review P3).
    function setAdding(on) {
      if (on) { applyBtn.setAttribute('aria-disabled', 'true'); applyBtn.setAttribute('data-ht-adding', '1'); }
      else { applyBtn.removeAttribute('aria-disabled'); applyBtn.removeAttribute('data-ht-adding'); }
    }
    if (applyBtn) {
      applyBtn.setAttribute('aria-live', 'polite');
      applyBtn.addEventListener('click', function () {
        var target = applyTarget || lastSize;
        if (applyBtn.getAttribute('aria-disabled') === 'true') return;
        if (!applySize(target)) return;
        if (!onPdpNow()) { applyBtn.textContent = '✓ Size ' + target + ' selected'; setTimeout(function () { applyBtn.textContent = applyLabel(target); }, 1600); return; }
        setAdding(true);
        applyBtn.textContent = 'Adding…';
        addWhenReady(function (state) {
          var msg = { added: '✓ Size ' + target + ' added', soldout: 'Size ' + target + ' is sold out', busy: 'Already adding — check your cart', error: 'Couldn’t add — see the message above', slow: 'Taking long — tap Add to Cart', gone: 'Tap Add to Cart' }[state];
          applyBtn.textContent = msg;
          setTimeout(function () { setAdding(false); applyBtn.textContent = applyLabel(target); }, state === 'added' ? 2200 : 3000);
        });
      });
    }
  }

  // 2026-09-13: file eksternal `defer` (bukan inline lagi). boot() dipanggil
  // sekali saat muat dan lagi tiap theme editor me-render ulang section
  // (shopify:section:load) — init() dan tombol collapse sudah idempotent.
  function boot() {
  LANG = document.querySelector('.ht-fitfinder[data-ff-lang="id"]') ? 'id' : 'en';
  IMPERIAL = !!document.querySelector('.ht-fitfinder[data-ff-units="imperial"]');
  document.querySelectorAll('.ht-fitfinder__form').forEach(init);

  // MOBILE collapsible: the cream card toggles the finder open/closed (+/−).
  // Scoped to each .ht-fitfinder section so the home and PDP instances are
  // independent; CSS reveals .ht-fitfinder__finder when .is-ff-open is set.
  document.querySelectorAll('[data-ff-collapse]').forEach(function (btn) {
    if (btn.dataset.ffBound) return; btn.dataset.ffBound = '1';  // idempotent if the section renders twice
    var section = btn.closest('.ht-fitfinder');
    if (!section) return;
    var sign = btn.querySelector('[data-ff-sign]');
    btn.addEventListener('click', function () {
      var open = section.classList.toggle('is-ff-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (sign) { sign.textContent = open ? '−' : '+'; }
    });
  });
  }
  window.htFitFinderBoot = boot;
  boot();
  document.addEventListener('shopify:section:load', boot);

  // "Find my size" (PDP size row) links to #fitfinder — on mobile the card may
  // be COLLAPSED, so the shopper would land on a closed card and have to tap
  // again (audit 2026-07-16). Open it whenever a link targeting it is clicked.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#fitfinder"]');
    if (!a) return;
    var target = document.getElementById('fitfinder');
    var section = target && (target.classList.contains('ht-fitfinder') ? target : target.closest('.ht-fitfinder'));
    if (section && !section.classList.contains('is-ff-open')) {
      var btn = section.querySelector('[data-ff-collapse]');
      if (btn) btn.click();
    }
  });
})();
